import React from "react";
import "../styling/LeftMenu.css";
import {
  IoHome
} from "react-icons/io5";
import {
  BsBookmark,
  BsBookmarkFill,
  BsCalendar,
  BsCalendarFill
} from "react-icons/bs";
import {
  BiSolidBarChartAlt2
} from "react-icons/bi";
import {
  FaRegUserCircle,
  FaUserCircle
} from "react-icons/fa";

const LeftMenu = ({ 
  selectedMenuItem, 
  onMenuItemClick,
  isMobileOpen = false,
  onRequestClose,
  // ⬇️ new props to mirror the DefaultSidebar behavior
  onEventClick,
  clientRecord,
}) => {
  const menuItems = [
    {
      text: "Dashboard",
      icon: <IoHome className="icon" />,
      filledIcon: <IoHome className="icon" />,
    },
    {
      text: "Events",
      icon: <BsBookmark className="icon" />,
      filledIcon: <BsBookmarkFill className="icon" />,
    },
    {
      text: "Clients",
      icon: <FaRegUserCircle className="icon" />,
      filledIcon: <FaUserCircle className="icon" />,
    },
    {
      text: "Calendar",
      icon: <BsCalendar className="icon" />,
      filledIcon: <BsCalendarFill className="icon" />,
    },
    {
      text: "Analytics",
      icon: <BiSolidBarChartAlt2 className="icon" />,
      filledIcon: <BiSolidBarChartAlt2 className="icon" />,
    },
  ];

  const handleClick = (menuItem) => {
    onMenuItemClick(menuItem);
    onRequestClose?.();
  };

  const handleOpenEvents = () => {
    if (!clientRecord) return;        // optional guard
    onEventClick?.(clientRecord);     // same as DefaultSidebar
    onRequestClose?.();               // close drawer on mobile
  };

  const isEventsDisabled = !clientRecord; // optional: disable if nothing selected

  return (
    <nav
      id="left-menu"
      className={`left-menu ${isMobileOpen ? "left-menu--open" : ""}`}
      aria-label="Primary"
      aria-hidden={!isMobileOpen ? undefined : false}
    >
      <ul>
        {menuItems.map((menuItem) => {
          const isActive = selectedMenuItem === menuItem.text;
          return (
            <li
              key={menuItem.text}
              className={isActive ? "selected" : ""}
              onClick={() => handleClick(menuItem)}
            >
              <span className="indicator"></span>
              <span>{menuItem.text}</span>
              {isActive ? menuItem.filledIcon : menuItem.icon}
            </li>
          );
        })}
      </ul>

      {/* Footer: Open Events (same behavior as DefaultSidebar button) */}
      {/* <div className="left-menu__footer">
        <button type="button" className="left-menu__link"
          onClick={handleOpenEvents}
          disabled={!clientRecord}
          title={!clientRecord ? "Select a client to view events" : "Open Events"}>
          Open Events
        </button>
      </div> */}
    </nav>
  );
};

export default LeftMenu;
